import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Container, Row, Col, Label } from 'reactstrap';
import { Link } from "react-router-dom";
import LoadingImage from "../../comum/components/LoadingImage";
import ModalAviso from "../../comum/components/ModalAviso";
import ModalForm from "../../comum/components/ModalForm";
import { IconeEditar, IconeCopiar, IconeProibido, IconeCarregar, IconeDelete } from "../../comum/components/Icones";
import Footer from "../../comum/components/Footer";
import FooterContent from "../../comum/components/FooterContent";
import { buscaFiltrarVazio, buscaSemResultado } from "../../../utils/mensagens";
//import CardAgendamentoNotaFiscal from "";

@inject("store")
@observer
export class TabelaGrupoEmail extends Component {

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
        this.loginStore = this.props.store.loginStore;
        if (this.controller.colunas.length == 1) {
            this.controller.colunas.push(
                {
                    dataField: 'acoes',
                    isDummyField: true,
                    text: 'Acões',
                    formatter: (cell, row) => {
                        return <Col className={"text-right"}>
                            <IconeProibido title={"Excluir"} tamanho="lg" className="m-2" onClick={() => {
                                this.controller.emailSelecionado = row;
                                this.controller.mostrarModalConfirmacao = true;
                                this.controller.listarCnpjsPertentencesMesmoRadical(this.controller.clienteSelecionado.cnpj);
                            }} />

                        </Col>
                    }
                })
        }

    }

    can = (operacao = "C", tarefa = "NotasFiscaisAde") => this.loginStore.can(tarefa, operacao)



    confirmAcao() {
        if (this.controller.mostrarModalConfirmacao) {
            return (<ModalForm salvando={this.controller.excluindoNotas}
                labelCancelar="NÃO"
                labelConfirmar="SIM"
                habilitaSalvar={this.controller.loadingAplicandoExcluirEmail === false}
                onClickCancelar={this.controller.fecharTodosModais}
                onClickSalvar={() => this.controller.ExcluirEmail(this.controller.emailSelecionado, this.controller.aplicarMesmoRadical)}>
                <h2>Confirmar exclusão?</h2>

                {!this.controller.loadingCnpjsMesmoRadical && this.controller.aplicarMesmoRadical ? (<div>
                    <p>CNPJs que serão aplicados as alterações</p>
                    {this.controller.cnpjsPertentencesMesmoRadical.map(cliente => {

                        return (<Row>
                            <Col xs={9}> <Label>{cliente.Razao}</Label> </Col>
                            <Col> <IconeProibido title={"Excluir"} tamanho="lg" className="m-2" onClick={() => {
                                this.controller.cnpjsPertentencesMesmoRadical = this.controller.arrayRemove(this.controller.cnpjsPertentencesMesmoRadical, cliente)
                                if (this.controller.cnpjsPertentencesMesmoRadical == 0) {this.controller.fecharTodosModais() }
                            }} /> </Col>
                        </Row>)
                    })}
                </div>)
                    : this.controller.aplicarMesmoRadical ?(<LoadingImage />) : ""
                }
                {this.controller.loadingAplicandoExcluirEmail && <div>
                    <p>Aplicando alterações </p><IconeCarregar cor="#001C43" className="my-0" tamanho="1x" />
                </div>
                }
            </ModalForm>
            )
        }

    }

    render() {
        let lista = this.controller.grupoEmail.length > 0 ? this.controller.grupoEmail : [];

        let loading = this.controller.loading;
        return (
            <Container fluid className="tabela-container">
                {this.confirmAcao()}
                {(!this.controller.filtrado) ?
                    <Row>
                        <Col className="mt-3" xs={12}>
                            <span className="mensagem-filtrar">
                                {buscaFiltrarVazio}
                            </span>
                        </Col>
                    </Row>
                    :
                    <ToolkitProvider
                        keyField="Id"
                        data={lista.slice()}
                        columns={[...this.controller.colunas]}
                    >
                        {props => (
                            <div>


                                <BootstrapTable bootstrap4
                                    striped
                                    bordered={false}
                                    
                                    {...props.baseProps}
                                />

                            </div>)
                        }
                    </ToolkitProvider>
                }

                <Footer>
                    <FooterContent>
                        {this.controller.total !== null && <div className="justify-content-between">
                            <div><b>{this.controller.loading ? <IconeCarregar tamanho="1x" className='mr-1' cor="#001C43" /> : lista.slice().length}</b> Registros no Total - {this.controller.clienteCarregado}
                            </div>
                        </div>}

                    </FooterContent>

                </Footer>

            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/atualizacaocadastral/components/TabelaGrupoEmail.js